import { render, staticRenderFns } from "./DataBaseForm.vue?vue&type=template&id=0cb7f1bc&scoped=true"
import script from "./DataBaseForm.vue?vue&type=script&lang=js"
export * from "./DataBaseForm.vue?vue&type=script&lang=js"
import style0 from "./DataBaseForm.vue?vue&type=style&index=0&id=0cb7f1bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7f1bc",
  null
  
)

export default component.exports